
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article-classification/[classificationUrlId]",
      function () {
        return require("private-next-pages/article-classification/[classificationUrlId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article-classification/[classificationUrlId]"])
      });
    }
  